'use strict';

import keyMirror from 'react/lib/keyMirror';

export default keyMirror({
  STAMP_OTHER_ZINES: null,
  ZINE_PENDING_STAMPS: null,
  ADD_STAMP_TO_ZINES: null,
  ADD_STAMPS_TO_ZINE: null,
  PINTEREST_PICKER: null,
  APPROVE_PENDING_STAMP: null,
  REJECT_PENDING_STAMP: null,
  ACTIVITIES: null,
  STAMP_LIKES: null,
  USER_SUBSCRIBERS: null,
  USER_SUBSCRIPTIONS: null,
  IMAGE_USED_IN_STAMPS: null,
  DRAFTS: null,
  LEAVE_DRAFT_FEEDBACK: null,
  DRAFT_FEEDBACKS: null,
  POST_STAMP: null
});


/** WEBPACK FOOTER **
 ** ./constants/SidebarTypes.js
 **/